import { type Image } from '@/interfaces';

export const broknByMainImages: Image[] = [
  {
    altText: 'images.altText.ringGoldPink',
    imageDirectoryPath: 'brokn-by-bague-rubis',
    extension: 'jpg',
    contents: [{ title: 'broknBy.mainSection.title', text: 'broknBy.mainSection.content' }],
    width: 900,
    height: 675,
    aspectRatio: 'horizontal',
    class: 'lg:h-80 w-full',
    animation: 'fade-right'
  },
  {
    altText: 'images.altText.ringSilverDiamonds',
    imageDirectoryPath: 'brokn-by-bague-carre',
    extension: 'jpg',
    contents: [{ title: 'broknBy.mainSection.title2', text: 'broknBy.mainSection.content2' }],
    width: 900,
    height: 675,
    aspectRatio: 'horizontal',
    class: 'lg:h-80 w-full',
    animation: 'fade-left'
  }
];
